<template>
  <div class="topbar">
    <div class="topbar-left">
      <Button 
        v-if="isMobile"
        icon="pi pi-bars"
        class="p-button-text p-button-plain menu-toggle"
        @click="$emit('toggle-sidebar')"
      />
      <!-- Masaüstü için logo solda -->
      <div class="logo-desktop">
        <img src="https://lifeguardpanel.com.tr/uploads/logo.webp" alt="LifeGuard" class="logo-image" />
      </div>
    </div>
    
    <!-- Mobil için ortalanmış logo -->
    <div class="logo-mobile">
      <img src="https://lifeguardpanel.com.tr/uploads/logo.webp" alt="LifeGuard" class="logo-image" />
    </div>

    <div class="topbar-right">
      <div class="user-info">
        <div class="user-avatar">
          <i class="pi pi-user"></i>
        </div>
        <div class="user-details">
          <span class="user-name">{{ userName }}</span>
          <span class="user-role">{{ getUserRoleText }}</span>
        </div>
      </div>
      <Button 
        icon="pi pi-sign-out" 
        class="p-button-danger logout-btn"
        @click="logout"
        v-tooltip="'Çıkış Yap'"
      />
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import Button from 'primevue/button';

export default {
  name: 'TopBar',
  components: {
    Button
  },
  emits: ['toggle-sidebar'],
  setup() {
    const store = useStore();
    const router = useRouter();

    const userName = computed(() => store.getters.userName);
    const userRole = computed(() => store.getters.userRole);
    const isMobile = computed(() => store.getters.isMobile);

    const getUserRoleText = computed(() => {
      switch (userRole.value) {
        case 'admin': return 'Yönetici';
        case 'driver': return 'Sürücü';
        case 'healthworker': return 'Sağlık Personeli';
        default: return 'Kullanıcı';
      }
    });

    const logout = () => {
      store.dispatch('logout');
      router.push('/login');
    };

    return {
      userName,
      getUserRoleText,
      isMobile,
      logout
    };
  }
}
</script>

<style scoped>
.topbar {
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  color: white;
  padding: 0 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
  box-shadow: 0 2px 10px rgba(220, 38, 38, 0.3);
  position: relative;
  z-index: 100;
  border-bottom: 1px solid #fecaca;
}

/* Masaüstü logo - normal solda */
.logo-desktop {
  display: flex;
  align-items: center;
}

/* Mobil logo - ortada */
.logo-mobile {
  display: none;
}

.logo-image {
  height: 45px;
  width: auto;
  object-fit: contain;
}

/* Mobil için */
@media (max-width: 768px) {
  .logo-desktop {
    display: none; /* Masaüstü logoyu gizle */
  }
  
  .logo-mobile {
    display: flex; /* ✅ BU SATIRI DEĞİŞTİR: none yerine flex */
    position: absolute;
    left: 40%;
    transform: translateX(-50%);
    align-items: center;
    justify-content: center;
  }
  
  .logo-image {
    height: 35px;
  }
}

.topbar-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

/* Ortalanmış logo container */
.logo-center {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-image {
  height: 45px;
  width: auto;
  object-fit: contain;
}

.menu-toggle {
  color: white !important;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  transition: all 0.2s;
}

.menu-toggle:hover {
  background: rgba(255, 255, 255, 0.1) !important;
}

.topbar-right {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 1rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.2s;
}

.user-info:hover {
  background: rgba(255, 255, 255, 0.15);
}

.user-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
}

.user-avatar i {
  font-size: 1.1rem;
}

.user-details {
  display: flex;
  flex-direction: column;
}

.user-name {
  font-weight: 600;
  font-size: 0.875rem;
}

.user-role {
  font-size: 0.75rem;
  opacity: 0.9;
}

.logout-btn {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  transition: all 0.2s;
  background: rgba(239, 68, 68, 0.9) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
}

.logout-btn:hover {
  background: rgba(220, 38, 38, 0.9) !important;
  transform: scale(1.05);
}


@media (max-width: 768px) {
  .topbar {
    padding: 0 1rem;
  }
  
  .logo-image {
    height: 35px;
  }
  
  /* Mobil için user-info düzeni */
  .user-info {
    padding: 0.4rem 0.6rem;
    gap: 0.5rem;
    background: rgba(255, 255, 255, 0.15);
    min-width: auto;
  }
  
  /* Mobilde yazıları daha küçük ve tek sıra yapalım */
  .user-details {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
  }
  
  .user-name {
    font-size: 0.75rem;
    white-space: nowrap;
  }
  
  .user-role {
    font-size: 0.65rem;
    opacity: 0.8;
    white-space: nowrap;
  }
  
  .user-avatar {
    width: 28px;
    height: 28px;
  }
  
  .user-avatar i {
    font-size: 0.9rem;
  }
}

/* Çok küçük ekranlar için (480px altı) */
@media (max-width: 480px) {
  .user-details {
    flex-direction: column;
    gap: 0.1rem;
  }
  
  .user-name,
  .user-role {
    font-size: 0.6rem;
    line-height: 1;
  }
  
  .user-info {
    padding: 0.3rem 0.5rem;
  }
}

/* Çok daha küçük ekranlar (360px altı) */
@media (max-width: 360px) {
  .user-details {
    display: none; /* Çok küçük ekranlarda sadece icon göster */
  }
  
  .user-info {
    padding: 0.5rem;
  }
}



@media (max-width: 480px) {
  .topbar {
    height: 60px;
  }
  
  .logo-image {
    height: 30px;
  }
  
  .user-avatar {
    width: 32px;
    height: 32px;
  }
  
  .logout-btn,
  .menu-toggle {
    width: 36px;
    height: 36px;
  }
}

/* Çok küçük ekranlar için logo boyut ayarı */
@media (max-width: 360px) {
  .logo-image {
    height: 25px;
  }
}
</style>